import Tab from "@mui/material/Tab"
import Tabs from "@mui/material/Tabs"
import { Link as RouterLink, useLocation } from "react-router-dom"

export const TEMPLATE_TAB_PATHS = {
  email: "/templates/email",
  sms: "/templates/sms",
}

/**
 * Email / SMS switch shared by the two template list pages, which keep their
 * own routes (/templates/email, /templates/sms) behind one "Templates" link.
 */
export default function TemplatesTabs() {
  const location = useLocation()
  const value = location.pathname.startsWith(TEMPLATE_TAB_PATHS.sms)
    ? TEMPLATE_TAB_PATHS.sms
    : TEMPLATE_TAB_PATHS.email

  return (
    <Tabs value={value} sx={{ mb: 2 }}>
      <Tab
        label="Email"
        value={TEMPLATE_TAB_PATHS.email}
        component={RouterLink}
        to={TEMPLATE_TAB_PATHS.email}
      />
      <Tab
        label="SMS"
        value={TEMPLATE_TAB_PATHS.sms}
        component={RouterLink}
        to={TEMPLATE_TAB_PATHS.sms}
      />
    </Tabs>
  )
}
